// Member notes DTOs (architecture sprint-12 §7.2, §7.5).
import type { LocalDate } from '@shared/calendar';
import type { NoteKind, NoteReviewDto } from '@shared/note-rules';
import type { NoteShiftDto } from '@shared/shifts';

export type { NotesReviewDto, NotesReviewItemDto, OwnNoteDto, OwnNoteProjectDto } from '@shared/note-rules';

export interface Note {
  id: string;
  date: LocalDate;
  description: string;
  subject: { id: string; name: string; current: boolean };
  author: { id: string; name: string };
  createdAt: string;
  updatedAt: string;
  edited: boolean;
  /** true only in Admin includeDeleted lists. */
  deleted: boolean;
  /** Sprint 13 (§13): the linked shift, if any. */
  shift?: NoteShiftDto | null;
  /** Sprint 15: optional so an older payload reads as a staff note nobody but an Admin edits. */
  kind?: NoteKind;
  review?: NoteReviewDto | null;
  canEdit?: boolean;
}

export interface NotePage {
  items: Note[];
  nextCursor: string | null;
}

export interface NoteSubject {
  id: string;
  name: string;
  current: boolean;
}

export interface NoteRevisionSide {
  date: LocalDate;
  description: string;
  subjectUserId: string;
  subjectName: string;
}

export interface NoteRevision {
  id: string;
  action: 'edited' | 'deleted';
  before: NoteRevisionSide;
  after: NoteRevisionSide | null;
  actor: { id: string; name: string };
  at: string;
}

export interface NoteHistory {
  note: Note;
  items: NoteRevision[];
}

export interface NoteFilters {
  from: LocalDate;
  to: LocalDate;
  userId: string | null;
  includeDeleted: boolean;
  /** Sprint 15 (§9.1): To review (no dates are sent) and the shift filter from a notification. */
  review?: boolean;
  shiftId?: string | null;
}

export const NOTE_MAX_LENGTH = 2000;
